<template>
  <v-menu
    transition="scroll-y-transition"
    bottom
    origin="center center"
  >
    <template #activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
      >
        <v-btn
          outlined
          rounded
          class="white--text border-white text-lowercase"
        >
          evo | nitro<span v-if="plan == 'full'">+</span><i class="fa fa-chevron-down ml-1 mt-1" />
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-list>
        <v-list-item
          v-for="platform of platforms"
          :key="platform.id"
          @click.prevent="onClick(platform)"
        >
          <v-list-item-title>
            {{ platform.plataformName }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click.prevent="logout">
          <v-list-item-title> Sair </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { redirect } from '@/utils/misc'
import { logout } from '@/utils/logout'
export default {
  computed: {
    ...mapGetters(['authUser','platforms', 'plan']),
  },
  mounted() {
    if(this.platforms.length == 0 && window.location.host != 'nitro.test') {
      this.getPlatforms()
    }
  },
  methods: {
    ...mapActions(['isLoading','getPlatforms',]),
    logout,
    onClick(platform) {
      this.isLoading()
      const action =
        platform.id === 8
          ? this.getUrlFromEvolucionalAPI(platform)
          : this.getUrlFromNitroAPI(platform)
      action
        .then((url) => {
          redirect(url)
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erro',
            text: `Erro ao se conectar a plataforma ${platform.platformName}.`
          })
          this.isLoading(false)
        })
    },
    getUrlFromNitroAPI(platform) {
      return axios
        .get(`/api/v1/platform/login-link/${platform.platformId}`)
        .then(({ data: { data: result } }) => {
          return result.url
        })
    },
    getUrlFromEvolucionalAPI(platform) {
      return axios
        .post(platform.api, {
          userID: this.authUser.userid,
          schoolId: this.authUser.schoolid,
          token: platform.token,
          assessmentModel: platform.assessmentModelId
        })
        .then(({ data: result }) => {
          return result.redirectUrl
        })
    }
  }
}
</script>
